import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

// The ONE site footer (Leon): the same marketing footer on every page EXCEPT the
// immersive viewer. Brand + tagline, the marketing jumps (which route to the landing
// sections from anywhere via `to="/" hash=…`), and a bottom bar carrying © + the legal
// nav (Regulamin, Polityka prywatności) + language. Previously three divergent footers
// (landing / comparison / the compact chrome shell) had drifted apart and the home page
// was missing the legal links entirely — this unifies them into one component.
export function SiteFooter() {
  const { t } = useTranslation("landing");
  const { t: tCommon } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-paper">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-6 py-12 sm:grid-cols-2 sm:px-8">
        <div>
          <Link
            to="/"
            className="font-display text-lg font-semibold tracking-tight text-foreground"
          >
            {tCommon("app.name")}
          </Link>
          <p className="mt-2 max-w-xs text-sm text-muted-foreground">{t("footer.tagline")}</p>
        </div>
        <nav
          aria-label={t("footer.linksHeading")}
          className="flex flex-col gap-2.5 text-sm sm:items-end"
        >
          {/* Marketing jumps: route to the landing sections so they work from any page. */}
          <Link
            to="/"
            hash="how"
            className="text-foreground/80 transition-colors hover:text-primary"
          >
            {t("footer.howItsMade")}
          </Link>
          <Link
            to="/"
            hash="trust"
            className="text-foreground/80 transition-colors hover:text-primary"
          >
            {t("footer.guarantee")}
          </Link>
          <Link to="/upload" className="text-foreground/80 transition-colors hover:text-primary">
            {t("footer.start")}
          </Link>
        </nav>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-6 gap-y-3 px-6 py-4 text-xs text-muted-foreground sm:px-8">
          <p>
            © {year} {t("footer.rights")}
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <nav className="flex items-center gap-4" aria-label={tCommon("legal:footerNav")}>
              <Link to="/regulamin" className="transition-colors hover:text-foreground">
                {tCommon("legal:documents.regulamin")}
              </Link>
              <Link to="/polityka-prywatnosci" className="transition-colors hover:text-foreground">
                {tCommon("legal:documents.polityka-prywatnosci")}
              </Link>
            </nav>
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </footer>
  );
}
